import { useState, useEffect } from 'react';

/**
 * Hook to detect current device type based on viewport width
 * Returns 'mobile', 'tablet', or 'desktop'
 */
export const useDeviceType = () => {
  const [deviceType, setDeviceType] = useState('desktop');

  useEffect(() => {
    const updateDeviceType = () => {
      const width = window.innerWidth;
      if (width < 768) {
        setDeviceType('mobile');
      } else if (width < 1024) {
        setDeviceType('tablet');
      } else {
        setDeviceType('desktop');
      }
    };

    updateDeviceType();
    window.addEventListener('resize', updateDeviceType);
    return () => window.removeEventListener('resize', updateDeviceType);
  }, []);

  return deviceType;
};

/**
 * Get responsive value based on device type
 * Falls back to larger device values if smaller not specified
 */
export const getResponsiveValue = (valueObj, deviceType) => {
  if (!valueObj || typeof valueObj !== 'object') return valueObj;
  
  // Try to get value for current device, fallback to larger devices
  if (deviceType === 'mobile') {
    return valueObj.mobile || valueObj.tablet || valueObj.desktop || '';
  }
  if (deviceType === 'tablet') {
    return valueObj.tablet || valueObj.desktop || '';
  }
  return valueObj.desktop || '';
};

export default useDeviceType;
